<template>

  <div class="wrapper">

    <div class="header">

      <div class="logo">
        <img src="@/assets/signup.log.png" @click="backIndex">
      </div>

      <div class="header-right">

        <span class="tips">
            还未注册？
        </span>

        <div class="blue-button">

          <router-link to="/signup" style="color:white">
            注册
          </router-link>
        </div>


      </div>

    </div>

    <div class="main">

      <div class="title">

        平台登陆

      </div>

      <div class="input">
        <el-input v-model="account" placeholder="请输入账号或手机号"></el-input>
      </div>

      <div class="input">
        <el-input v-model="password" placeholder="请输入密码" show-password></el-input>
      </div>

      <div class="input">

        <div class="captcha_code">
          <el-input  v-model="captcha" placeholder="请输入验证码" size="medium" style="width: 15vw"></el-input>
          <img :src="getImgCodeUrl" @click="changeUrl">
        </div>
      </div>

      <div class="blue-button" @click="submit">
        登陆
      </div>

      <router-link to="/forget" class="forget">
        忘记密码？
      </router-link>


    </div>


  </div>


</template>

<script>


import {login} from '../api/userMG'
import md5 from 'js-md5';


export default {
  name: "Login",
  data: () => {
    return {
      imgCodeUrl: "/api/ubiboat_website/user/imgCode?time=",
      account: "",
      password: "",
      captcha: "",
      time: new Date().getTime(),
    }
  },
  mounted() {
  },
  methods: {
    changeUrl() {
      return this.time = new Date().getTime();
    },


    backIndex() {
      window.location.href = "http://ubiboat.powerlbs.com"
    },
    submit() {

      let that = this;
      login(
        {
          "type": 1,
          "account": this.account,
          "pwd": md5(this.password),
          "imgCode": this.captcha

        }
      ).then(function (response) {

        if (response.status != 200) {
          that.$message.warning(response.message);
        } else {

          //      that.$message.success("");

          that.$store.commit("login", response.data);

          that.$router.push("/")
        }
      }).catch(e => {

        console.log(e);
        that.$message.error("网络链接异常，请稍后再试！")
      })


    }


  },
  computed: {
    getImgCodeUrl() {
      return this.imgCodeUrl + this.time;
    }
  }


}

</script>


<style scoped>

.el-input__inner {
  height: 47px !important;
}

a:link {
  color: #099dfd
}

a:visited {
  color: #099dfd
}


a:hover {
  color: #099dfd
}

a:active {
  color: #099dfd
}

/*包含以下四种的链接*/
a {
  text-decoration: #099dfd;
}

/*正常的未被访问过的链接*/
a:link {
  text-decoration: #099dfd;
}

/*已经访问过的链接*/
a:visited {
  text-decoration: #099dfd;
}

/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: #099dfd;
}

/* 正在点击的链接*/
a:active {
  text-decoration: #099dfd;
}


.header {
  display: flex;
  justify-content: space-between;
  height: 10vh;
  background-color: #ffffff;
  align-items: center;
  box-shadow: 0 1vw 1vw 0 rgb(0 0 0 / 15%);
  padding: 0 5vw
}


.header-right {
  display: flex;
  justify-content: center;
  align-items: center;
}


.blue-button {
  background-color: #429df6;
  color: #ffffff;
  text-align: center;
  width: 5.5vw;
  height: 2vw;
  line-height: 2vw;
  border-radius: 0.3vw;
  cursor: pointer;

}

.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
}

.main .title {
  font-size: 1.8vw;
  margin-bottom: 2vw;
}

.main .input {
  width: 30vw;
  margin-bottom: 2vw;
}


.main .blue-button {
  width: 30vw;
  height: 2.5vw;
  line-height: 2.5vw;
}

.forget {
  margin-top: 1.2vw;
  width: 8vw;
  cursor: pointer;
  margin-left: -21.5vw;
  font-size: 0.9vw;
}

.logo img {
  cursor: pointer;
  width: 20vw;
}

.captcha_code img {
  width: 11.5vw;
  height: 2.5vw;
  margin-bottom: -0.8vw;
  margin-left: 3vw;
  cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/views/Login.vue